import React, { memo } from 'react';
import map from 'lodash/map';
import size from 'lodash/size';
import DefaultParentItem from 'COMPONENTS/home/landings/parent/default';
import SkeletonMenu from 'COMPONENTS/skeleton_list_loader/skeleton_menu';
import { useSelector } from 'react-redux';
import { CATEGORIES } from 'MODULES/CATEGORIES';
import { Link } from 'react-router-dom';
import { PP_URLS } from 'CONFIG/PP_URLS';

const ParentLanding = ({ i18n, lang }) => {
    const categories = useSelector(state => state.categories.categories);
    return (
        <>
            {size(categories.root) === 0 && <SkeletonMenu />}
            {size(categories.root) > 0 && map(categories.root, cat => [
                cat.id !== CATEGORIES.whereToBuy && <DefaultParentItem key={`id_${cat.id}`} cat={cat} />
            ])}
            <Link
                to={{
                    pathname: PP_URLS.LANDING(lang, 'discount')
                }}
                className="cat-list cat-garden"
            >
                <div className="category-level-0 ">

                    <i className="pp-ico pp-landing pp-percent" aria-hidden="true" />
                    <div>
                        <h2>
                            {' '}
                            {i18n.__('Discount products')}
                        </h2>
                    </div>
                </div>
            </Link>

        </>
    );
};

export default memo(ParentLanding);
